(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
(() => {
  if (!('IntersectionObserver' in window)) return;
  const observed = new WeakSet();
  const visible = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    visible.forEach(element => { if (!element.isConnected) visible.delete(element); });
    document.body.classList.toggle('salon-buy-area-visible', visible.size > 0);
  }, { rootMargin: '70px 0px 70px 0px' });
  const observe = () => {
    document.querySelectorAll('[data-salon-purchase]').forEach(element => {
      if (!observed.has(element)) {
        observed.add(element);
        observer.observe(element);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-salon-purchase]').forEach(element => {
      observer.unobserve(element);
      observed.delete(element);
      visible.delete(element);
    });
    document.body.classList.toggle('salon-buy-area-visible', visible.size > 0);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
